import { all, delay, put, select, takeEvery } from "redux-saga/effects";
import _ from "lodash";
import { getListStationApi } from "../../../helpers/stationApi";
import {
    addAdvertiserApi,
    getAdvertiserApi,
    removeAdvertiserApi,
    sendInviteApi,
    updateAdvertiserApi,
    loadAdvertisersApi,
    updateAdvertiserPermissionsApi,
    loadMediaContentApi,
    dismissInviteApi,
    checkAdvertiserGaConnectionApi,
    getWeblogFilesByAdvertiserApi,
    ga4InviteToConnectApi,
    updateCutoverDateApi,
    deleteGA4ConnectionApi,
    getListPixelApi,
    createNewPixelApi,
    updatePixelAdvertiserApi,
    sendAlertForAdvertiserConnection,
    loadAdvertisersTeamApi,
} from "../../../helpers/advertiserApi";
import {
    ADD_ADVERTISER_SAGA,
    CHECK_GA_CONNECTION_SAGA,
    addAdvertiser,
    GET_ADVERTISER_SAGA,
    GET_STATION_SAGA,
    getAdvertiser,
    getAdvertiserByFolderId,
    loadAdvertiser,
    loadAdvertiserDetail,
    NEXT_STEP_SAGA,
    REMOVE_ADVERTISER_SAGA,
    removeAdvertiser,
    setStep,
    UPDATE_ADVERTISER_DETAIL_SAGA,
    UPDATE_ADVERTISER_SAGA,
    updateAdvertiser,
    LOAD_ADVERTISERS,
    setAdvertisers,
    UPDATE_ADVERTISER_PERMISSIONS,
    setAdvertiserPermissions,
    setLoadAdvertisersStatus,
    LOAD_ADVERTISER_LOGO,
    Status,
    namespace as advertiserNamespace,
    SEND_INVITE,
    DISMISS_INVITE,
    getSelfAdvertisers,
    ADD_ADVERTISER_WITHOUT_GA_INVITE_SAGA,
    GET_WEBLOG_FILES,
    GA4_INVITE_TO_CONNECT,
    UPDATE_CUTOVER_DATE,
    DELETE_GA4_CONNECTION,
    DeleteConnectionStatus,
    GET_LIST_PIXEL,
    updatePixelStatusById,
    CREATE_ADVERTISER_PIXEL,
    UPDATE_PIXEL,
    SEND_ALERT_ADVERTISER_CONNECTION,
    UPDATE_STATUS
} from "./advertiser";

import {
    updateCampaign,
    namespace as campaignNamespace,
    getCampaignByAdvertiserId,
    removeCampaignData
} from "./campaign";

import {
    checkAdvertiserError,
    checkMultiMarketError,
    validateConnectionType,
    validateEmailInfo,
    validateIndustryCategorization
} from '../../../helpers/validate';
import constants, { ADVERTISER_SOURCE_TYPE, TRACKING_SOURCE_NAME } from '../../../helpers/constant'
import constant, {
    ADVERTISER_INVITE_TAB,
    ADVERTISER_DETAIL_TAB,
    CONNECT_GA_STATUS,
    ADVERTISER_STEP_ROUTE
} from "../../../helpers/constant"
import { modules } from 'veritone-redux-common';
import { ROUTE_HOME, ROUTE_ADVERTISER_EDIT_TAB } from "modules/routing";
import { showToast } from "./notification";

import { setOrgUser, namespace as userManagementNamespace } from './userManagement/actions';
import { setCampaigns, Status as campaignStatus } from './campaign/actions';
import { OWNER, EDITOR, VIEWER, DEFAULT_ADVERTISER_LOGO_EXPIRE_TIME } from '../../../helpers/constant';
import { redirectToAdvertiserTabs } from '../../modules/routing/actions';
import { getAdvertiserConnectInfo } from '../../../helpers/formatData';
import { DEFAULT_MESSAGE } from '../../../components/AdvertiserEmailInfo';
import { getAdvertiserSourceType } from "../../../helpers/common";

const {
    config: { getConfig },
    user: { selectUser }
} = modules;

function* getStationSaga(action) {
    const { advertiser } = action.payload;
    const config = yield select(getConfig);
    let offset = 0;
    const LIMIT = 100;
    const RETRY_MAX = 10;
    let retry = 0;
    let stations = [];
    let stationResult = null;

    yield put(loadAdvertiser(advertiser.advertiser_id, {
        loading: true,
        loaded: false
    }));

    while (!stationResult || (stationResult.length === LIMIT && retry < RETRY_MAX)) {
        stationResult = yield getListStationApi(config.urlApi, LIMIT, offset);
        offset = offset + LIMIT;
        retry = retry + 1;
        stations = [...stations, ...stationResult];
    }

    const getAdvertiserNew = yield select(getAdvertiser);
    const advertiserNew = getAdvertiserNew("editing");
    const stationList = _.get(advertiser, "stationList");
    let updatingStations = null;
    if (stationList) {
        const stationMap = stationList
            .filter(station => station.checked)
            .reduce((cum, station) => ({ ...cum, [station.stationId]: station }), {});
        updatingStations = stations.map(station => ({
            stationId: station.id,
            stationName: station.name,
            sourceTypeId: station.sourceTypeId,
            checked: !!stationMap[station.id]
        }));
    } else {
        updatingStations = stations.map(station => ({
            stationId: station.id,
            stationName: station.name,
            sourceTypeId: station.sourceTypeId,
            checked: true
        }));
    }
    yield put(updateAdvertiser({
        ...advertiserNew,
        stationList: updatingStations,
        stationLoading: false
    }));

    yield put(loadAdvertiser(advertiser.advertiser_id, {
        loading: false,
        loaded: true
    }));
}

export function* removeAdvertiserSaga(action) {
    const { advertiser, isShowToast = true, isRedirect } = action.payload;
    const config = yield select(getConfig);
    yield put(loadAdvertiser(advertiser.advertiser_id, {
        loading: true,
        loaded: false
    }));
    
    const data = yield removeAdvertiserApi(config.urlApi, advertiser.advertiser_id);
    if (data.error) {
        yield put(loadAdvertiser(advertiser.advertiser_id, {
            loading: false,
            loaded: true,
        }));
        
        const toast = {
            message: "Something went wrong",
            action: "Dismiss",
            type: constants.FAILED
        };
        return yield put(showToast(toast));
    }

    if(isRedirect){
        yield put({ type: ROUTE_HOME });
    }

    // delete watchlist in liveRead and pre-recorded
    yield put(removeAdvertiser(advertiser))

    const toast = {
        message: "Advertiser deleted",
        action: "Dismiss",
        type: constants.SUCCESS
    };
    isShowToast && (yield put(showToast(toast)));
}

function* sendInviteSaga(action) {
    const { advertiser } = action.payload;
    const { emailInfo, advertiser_id } = advertiser;
    const config = yield select(getConfig);
    const currentUser = yield select(selectUser);
    const userEmail = currentUser && currentUser.email;
    const emails = _.get(emailInfo, 'emails');
    const pixelId = _.get(emailInfo, 'pixelId');
    const advertiserDataSource = getAdvertiserSourceType(advertiser);
    const isPixelAdvertiser = advertiserDataSource === ADVERTISER_SOURCE_TYPE.PIXEL;

    if (emails) {
        yield put(loadAdvertiser(advertiser_id, { isUpdatingInvite: true }));
        yield put(updatePixelStatusById(advertiser_id, pixelId, Status.STATUS_LOADING));
        const data = yield sendInviteApi(
            config.urlApi,
            {
                ...emailInfo,
                advertiserId: advertiser_id,
                inviteCreatedEmail: userEmail,
                isPixelAdvertiser,
            });
        let toast;
        if (data.error) {
            toast = {
                message: "Fail sending invitation.",
                action: "Dismiss",
                type: constants.FAILED
            };
            yield put(updatePixelStatusById(advertiser_id, pixelId, Status.STATUS_ERROR));
        } else {
            toast = {
                message: "Invitation sent!",
                action: "Dismiss",
                type: constants.SUCCESS
            };
            const gaConnectionDetail = _.get(data, 'data.gaConnectionDetail', {});
            const newAdvertiserInfo = {
                ...advertiser,
                ...gaConnectionDetail,
                invite_sent_date: _.get(data, 'data.invite_sent_date', advertiser.invite_sent_date)
            }
            const advertiserConnectInfo = getAdvertiserConnectInfo(newAdvertiserInfo) || {};
            yield put(updateAdvertiser({
                ...newAdvertiserInfo,
                ...advertiserConnectInfo
            }));
            yield put(updatePixelStatusById(advertiser_id, pixelId, Status.STATUS_LOADED));
        }
        yield put(loadAdvertiser(advertiser_id, { isUpdatingInvite: false}));
        yield put(showToast(toast));
    }
}

function* dismissInviteSaga(action) {
    const { advertiser, isShowConnectionNotice } = action.payload;
    const advertiserId = _.get(advertiser, 'advertiser_id');
    const config = yield select(getConfig);

    if (advertiserId) {
        const data = yield dismissInviteApi(
            config.urlApi,
            {
                advertiserId,
                isShowConnectionNotice
            }
        );
        if (data.error) {
            const toast = {
                message: "Something went wrong",
                action: "Dismiss",
                type: constants.FAILED
            };
            return yield put(showToast(toast));
        } else {
            yield put(updateAdvertiser({
                ...advertiser,
                is_show_connection_notice: isShowConnectionNotice
            }));
        }
    }
}

function* checkGaConnectionSaga(action) {
    const { advertiser } = action.payload;
    const advertiserId = _.get(advertiser, 'advertiser_id');
    const config = yield select(getConfig);

    if (advertiserId) {
        yield put(updateAdvertiser({
            advertiser_id: advertiserId,
            gaConnectionLoadStatus: 'loading' //component will depend on this to display loading
        }));

        const data = yield checkAdvertiserGaConnectionApi(config.urlApi, advertiserId);
        let toast = {
            isShowCustomizedToast: true,
            position: { vertical: 'top', horizontal: 'right' },
            autoHideDuration: 6000,
        }
        if (!data || data.resError) {
            //API error
            yield put(updateAdvertiser({
                advertiser_id: advertiserId,
                gaConnectionLoadStatus: 'error'
            }));

            toast = {
              ...toast,
              message: 'Connection Test Failed',
              label: constant.FAILED,
              type: constant.FAILED
            };
        } else {
            //API success
            const { isConnected, error } = data;
            yield put(updateAdvertiser({
                advertiser_id: advertiserId,
                isConnected,
                gaConnectionLoadStatus: 'loaded',
                gaConnectionError: error //Google error
            }));

            if (isConnected) {
                  toast = {
                    ...toast,
                    message: 'Connection is active.',
                    label: constant.SUCCESS,
                    type: constant.SUCCESS,
                  };
            }else {
                toast = {
                    ...toast,
                    message: 'Connection Test Failed',
                    label: constant.FAILED,
                    type: constant.FAILED
                  };
            }
        }

        yield put(showToast(toast));
    }

}

function* addAdvertiserSaga(action) {
    const { advertiser } = action.payload;
    const { emailInfo } = advertiser;
    const config = yield select(getConfig);
    const state = yield select();
    const currentUser = yield select(selectUser);

    const advertisers = getSelfAdvertisers(state);

    // set state loading for adding advertiser
    yield put(loadAdvertiser("editing", {
        loading: true,
        loaded: false
    }));

    const advertiserInMultipleMarkets = _.get(currentUser, 'organization.kvp.features.attribute.advertiserInMultipleMarkets') === "enabled";
    const { trackingDataSourceName } = advertiser;
    const isWebUploadAdvertiser = trackingDataSourceName === TRACKING_SOURCE_NAME.WEB_UPLOAD;

    // validate advertiser
    const errMsg = checkAdvertiserError(advertiser, advertisers);
    const multiMarketErrMsg = checkMultiMarketError(advertiser, advertiserInMultipleMarkets);
    const validatedEmailInfo = validateEmailInfo(emailInfo, true);
    const validateEmail = !isWebUploadAdvertiser && (validatedEmailInfo.emailError || validatedEmailInfo.msgError);
    const industryCategorizationError = validateIndustryCategorization(advertiser);
    const trackingDataSourceNameError = validateConnectionType(advertiser);

    if (
        errMsg || 
        multiMarketErrMsg || 
        validateEmail || 
        !!industryCategorizationError ||
        trackingDataSourceNameError
    ) {
        return (
            yield put(updateAdvertiser({
                ...advertiser,
                errMsg,
                multiMarketErrMsg,
                emailInfo: validatedEmailInfo,
                industryCategorizationError,
                trackingDataSourceNameError,
            }))
        );
    }
    const userEmail = currentUser && currentUser.email;

    const normalizedEmailInfo = {
        invite_recipient_emails: validatedEmailInfo.emails,
        invite_created_email: userEmail,
        invite_recipient_name: '',
        invite_message: validatedEmailInfo.message,
        agent_content: validatedEmailInfo.agentContent,
    };
    
    let normalizedAdvertiser = {
      ...advertiser,
      is_multi_market: advertiser.isMultiMarket
    };

    if(isWebUploadAdvertiser) {
        normalizedAdvertiser.emailInfo = {};
    } else {
        normalizedAdvertiser.emailInfo = normalizedEmailInfo;
    }

    // Call advertiser api
    let createAdvertiserResult = yield addAdvertiserApi(config.urlApi, normalizedAdvertiser);
    
    yield put(loadAdvertiser("editing", {
        loading: false,
        loaded: true
    }));
    if (createAdvertiserResult.error) {
        const toast = {
            message: "Something went wrong creating an Advertiser",
            action: "Dismiss",
            type: constants.FAILED
        };
        yield put(showToast(toast));
        return;
    }
    const toast = {
        message: "New advertiser added",
        action: "Dismiss",
        type: constants.SUCCESS
    }
    const advertiserConnectInfo = getAdvertiserConnectInfo(createAdvertiserResult) || {};
    createAdvertiserResult = {
        ...createAdvertiserResult,
        ...advertiserConnectInfo,
        emailInfo
    };
    const { advertiser_id } = createAdvertiserResult;
    yield put(showToast(toast));
    yield put(addAdvertiser(createAdvertiserResult));
    yield put(redirectToAdvertiserTabs(advertiser_id, ADVERTISER_STEP_ROUTE));
}

function* addAdvertiserWithoutGAInviteSaga(action) {
    const { advertiser } = action.payload;
    const config = yield select(getConfig);
    const state = yield select();
    const currentUser = yield select(selectUser);

    const advertisers = getSelfAdvertisers(state);
    const advertiserInMultipleMarkets = _.get(currentUser, 'organization.kvp.features.attribute.advertiserInMultipleMarkets') === "enabled";

    // validate advertiser
    const errMsg = checkAdvertiserError(advertiser, advertisers);
    const multiMarketErrMsg = checkMultiMarketError(advertiser, advertiserInMultipleMarkets);

    if (errMsg || multiMarketErrMsg) {
        return (
            yield put(updateAdvertiser({
                ...advertiser,
                errMsg,
                multiMarketErrMsg
            }))
        );
    }

    // set state loading for adding advertiser
    yield put(loadAdvertiser("editing", {
        status: Status.STATUS_LOADING
    }));
    
    // Call advertiser api
    let createAdvertiserResult = yield addAdvertiserApi(config.urlApi, {
        ...advertiser,
        is_multi_market: advertiser.isMultiMarket
    });

    if (createAdvertiserResult.error) {
        const toast = {
            message: "Something went wrong creating an Advertiser",
            action: "Dismiss",
            type: constants.FAILED
        };

        yield put(loadAdvertiser("editing", {
            status: Status.STATUS_ERROR
        }));
        yield put(showToast(toast));
        return;
    }
    const toast = {
        message: "New advertiser added",
        action: "Dismiss",
        type: constants.SUCCESS
    }
    const advertiserConnectInfo = getAdvertiserConnectInfo(createAdvertiserResult) || {};
    createAdvertiserResult = {
        ...createAdvertiserResult,
        ...advertiserConnectInfo
    };
    yield put(loadAdvertiser("editing", {
        status: Status.STATUS_LOADED
    }));
    yield put(showToast(toast));
    yield put(addAdvertiser(createAdvertiserResult));
}

function* updateAdvertiserSaga(action) {
    const { advertiser, oldAdvertiser, isEmailInfoRequired, allowRedirect = true } = action.payload;
    let {
      activeStep,
      advertiser_id,
      folder_id,
      google_analytics_id,
      connect_status_ga,
      emailInfo,
      inviteMessage,
      inviteRecipients,
      trackingDataSourceName,
    } = advertiser;
    const newEmailInfo = emailInfo
      ? emailInfo
      : {
          emails: inviteRecipients,
          message: inviteMessage || DEFAULT_MESSAGE, //for advertiser that created without any invite sent before
          emailError: '',
          emailValue: '',
        };
    const config = yield select(getConfig);
    const currentUser = yield select(selectUser);
    // validate advertiser
    const getListAdvertiser = yield select(getAdvertiserByFolderId);
    const advertisers = getListAdvertiser(folder_id);
    const advertiserInMultipleMarkets = _.get(currentUser, 'organization.kvp.features.attribute.advertiserInMultipleMarkets') === "enabled";
    const isWebUploadAdvertiser = trackingDataSourceName === TRACKING_SOURCE_NAME.WEB_UPLOAD;
    const isChangeConnectionType = oldAdvertiser.trackingDataSourceName !== trackingDataSourceName;
    const isSendInvite = isChangeConnectionType && !isWebUploadAdvertiser;
    const errMsg = checkAdvertiserError(advertiser, advertisers);
    const multiMarketErrMsg = checkMultiMarketError(advertiser, advertiserInMultipleMarkets);
    const validatedEmailInfo = validateEmailInfo(newEmailInfo, isEmailInfoRequired);
    const validateEmail = isSendInvite && (validatedEmailInfo.emailError || validatedEmailInfo.msgError);
    const industryCategorizationError = validateIndustryCategorization(advertiser);
    const trackingDataSourceNameError = validateConnectionType(advertiser);

    if (
        errMsg || 
        multiMarketErrMsg || 
        validateEmail || 
        !!industryCategorizationError || 
        trackingDataSourceNameError
    ) {
        return yield put(updateAdvertiser({
            ...advertiser,
            advertiser_id: "editing",
            errMsg,
            multiMarketErrMsg,
            emailInfo: validatedEmailInfo,
            industryCategorizationError,
            trackingDataSourceNameError,
        }));
    }

    yield put(updateAdvertiser(
        {
            ...advertiser,
            advertiser_id: "editing",
            loading: true,
            loaded: false
        }
    ))

    const userEmail = currentUser && currentUser.email;

    // If email resend is not required don't pass the emailInfo.
    const normalizedEmailInfo = !isEmailInfoRequired ? undefined : {
        invite_recipient_emails: validatedEmailInfo.emails,
        invite_created_email: userEmail,
        invite_recipient_name: '',
        invite_message: validatedEmailInfo.message,
        agent_content: validatedEmailInfo.agentContent,
    };
    let advertiserData = {
        ...advertiser,
        is_multi_market: advertiser.isMultiMarket,
        emailInfo: normalizedEmailInfo,
        campaigns: oldAdvertiser.campaigns
    };
    if (!isSendInvite) {
        delete advertiserData.emailInfo;
    };
    if (!isChangeConnectionType) {
        delete advertiserData.trackingDataSourceName;
    };
    // call update advertiser api
    const updatingAdvertiser = yield updateAdvertiserApi(config.urlApi, advertiserData);
    if (updatingAdvertiser.error) {
        const message = _.get(updatingAdvertiser,
            "response.data.message.advertiser.running",
            "Something went wrong updating an Advertiser");
        const toast = {
            message,
            action: "Dismiss",
            type: constants.FAILED
        };
        return yield put(showToast(toast));
    }
    const updatedInviteRecipients =  isEmailInfoRequired ? validatedEmailInfo.emails : oldAdvertiser.inviteRecipients;
    const updatedInviteMessage = isEmailInfoRequired ? validatedEmailInfo.message : oldAdvertiser.inviteMessage;
    // update advertiser to redux
    const advertiserConnectInfo = getAdvertiserConnectInfo({ ...advertiser, ...updatingAdvertiser }) || {};
    yield put(updateAdvertiser(
        {
            ...advertiser,
            ...advertiserConnectInfo,
            ...updatingAdvertiser,
            campaigns: oldAdvertiser.campaigns,
            emailInfo: newEmailInfo,
            inviteRecipients: updatedInviteRecipients,
            inviteMessage: updatedInviteMessage,
            advertiserPixelDetailStatus: Status.STATUS_INITIAL
        },
        oldAdvertiser
    ));
    yield put(updateAdvertiser(
        {
            ...advertiser,
            ...updatingAdvertiser,
            advertiser_id: 'editing',
            activeStep: activeStep,
            loading: true,
            loaded: false,
            is_multi_market: updatingAdvertiser.is_multi_market
        }
    ));

    const toast = {
        message: "Advertiser Updated",
        action: "Dismiss",
        type: constants.SUCCESS
    };

    if(allowRedirect){
        yield put(showToast(toast));
        google_analytics_id && connect_status_ga === CONNECT_GA_STATUS.CONNECTED && (yield put(redirectToAdvertiserTabs(advertiser_id, ADVERTISER_STEP_ROUTE)))
        !(google_analytics_id && connect_status_ga === CONNECT_GA_STATUS.CONNECTED)  || _.isNull(google_analytics_id) && (yield put({
            type: ROUTE_ADVERTISER_EDIT_TAB,
            payload: {
                advertiserId: advertiser_id,
                tab: ADVERTISER_INVITE_TAB
            }
        }))

        yield put(redirectToAdvertiserTabs(advertiser_id, ADVERTISER_STEP_ROUTE));

        yield put(loadAdvertiser("editing", {
            loading: false,
            loaded: true
        }));
    }

    return {
        ...updatingAdvertiser,
        emailInfo: newEmailInfo
    }
}

function* getAdvertiserSaga(action) {
    const { advertiserId, currentTab } = action.payload;
    const config = yield select(getConfig);
    yield put(loadAdvertiser(advertiserId, {
        loading: true,
        loaded: false
    }));
    let res = yield getAdvertiserApi(config.urlApi, advertiserId);
    if (res.error) {
        const toast = {
            message: "Something went wrong",
            action: "Dismiss",
            type: constants.FAILED
        };
        return yield put(showToast(toast));
    }
    const { google_analytics_id, connect_status_ga } = res
    yield put(loadAdvertiser(advertiserId, {
        loading: false,
        loaded: true
    }));


    if(google_analytics_id && connect_status_ga === 1 && currentTab === ADVERTISER_INVITE_TAB) {
        yield put({
            type: ROUTE_ADVERTISER_EDIT_TAB,
            payload: {
                advertiserId: advertiserId,
                tab: ADVERTISER_DETAIL_TAB
            }
        })
    }

    //set active step for update advertiser
    const newActiveStep = currentTab === ADVERTISER_INVITE_TAB && !(google_analytics_id && connect_status_ga === CONNECT_GA_STATUS.CONNECTED) ? 1 : 0
    const advertiserConnectInfo = getAdvertiserConnectInfo(res) || {};

    const advertiser = {
        ...res,
        ...advertiserConnectInfo,
        loading: false,
        loaded: true,
        activeStep: newActiveStep,
    };
    yield put(updateAdvertiser(advertiser));
    yield put(addAdvertiser({
        ...advertiser,
        advertiser_id: "editing",
    }));
}

function* updateAdvertiserDetail(action) {
    const { advertiser_id } = action.payload;
    const config = yield select(getConfig);
    let advertiserDetail = yield getAdvertiserApi(config.urlApi, advertiser_id);
    if (advertiserDetail.error) {
        const toast = {
            message: "Something went wrong",
            action: "Dismiss",
            type: constants.FAILED
        };
        return yield put(showToast(toast));
    }
    const advertiserConnectInfo = getAdvertiserConnectInfo(advertiserDetail) || {};
    const campaigns = advertiserDetail.campaigns;
    yield all(campaigns.map(campaign => {
        return put(updateCampaign(campaign))
    }))
    yield (put(loadAdvertiserDetail({
        ...advertiserDetail,
        ...advertiserConnectInfo
    })));
}

function* nextStepSaga(action) {
    // set next step for add advertiser and edit advertiser
    const { advertiser } = action.payload;
    const { folder_id, activeStep } = advertiser;
    const getListAdvertiser = yield select(getAdvertiserByFolderId);
    const advertisers = getListAdvertiser(folder_id);
    const errMsg = validateAdvertiser(advertiser, advertisers);
    if (errMsg) {
        return (
            yield put(updateAdvertiser({
                ...advertiser,
                errMsg
            }))
        );
    }
    yield put(setStep(activeStep + 1));
}

function* loadAdvertiserOfCurrentUsersSaga(action) {
    const state = yield select();
    const config = yield select(getConfig);

    // fetching
    const res = yield loadAdvertisersApi(config.urlApi, 'self');

    if (!res || res.error) {
        const toast = {
            message: "Error loading advertisers !",
            action: "Dismiss",
            type: constants.FAILED
        };
        yield put(setLoadAdvertisersStatus(Status.STATUS_ERROR));
        yield put(showToast(toast));
        return Status.STATUS_ERROR;
    }

    const { data = [] } = res;
    const newById = {};
    const newAllIds = [];
    const campaignHashMap = {};
    let campaignIds = [];

    // calculate newAdvertiserSelf
    const newAdvertiserSelf = data.reduce((acc, advertiser) => {
        const advertiserId = advertiser.advertiser_id;
        const advertiserConnectInfo = getAdvertiserConnectInfo(advertiser) || {};
        if (!newById[advertiserId]) {
            newById[advertiserId] = {
                ...advertiser,
                ...advertiserConnectInfo
            };
            newAllIds.push(advertiserId);
            acc.push(advertiserId);
        }

        // process campaignHashMap
        const { campaigns = [] } = advertiser;
        campaigns.forEach(campaign => {
            const { campaign_id: campaignId } = campaign;
            campaignHashMap[campaignId] = campaign;
            campaignIds.push(campaignId);
        })

        return acc;
    }, []);
    const newAdvertiserData = {
        self: newAdvertiserSelf,
        selfStatus: Status.STATUS_LOADED,
        byId: newById,
        allIds: newAllIds
    }
    yield (put(setAdvertisers(newAdvertiserData)));
    const campaignLoadStatus = _.get(state, 'campaign.status');
    if (campaignLoadStatus !== campaignStatus.LOADED) {
        const campaignList = Object.values(campaignHashMap);
        campaignIds = _.uniq(campaignIds);
        yield put(setCampaigns(campaignList, campaignIds));
    }
    return Status.STATUS_LOADED;
}

function* loadAdvertiserOfTeamMembersSaga(action) {

    const state = yield select();
    const config = yield select(getConfig);

    // fetching
    const res = yield loadAdvertisersTeamApi(config.urlApi);

    if (!res || res.error) {
        const toast = {
            message: "Error loading advertisers of team members!",
            action: "Dismiss",
            type: constants.FAILED
        };
        yield put(setLoadAdvertisersStatus(Status.STATUS_ERROR));
        yield put(showToast(toast));
        return Status.STATUS_ERROR
    }

    const { data = [] } = res;
    const newById = {};
    const newAllIds = [];
    const campaignHashMap = {};
    let campaignIds = [];

    // calculate newAdvertiserTeam
    const newAdvertiserTeam = data.reduce((acc, member) => {
        const advertiserIds = member.advertisers.map(advertiser => {
            const advertiserId = advertiser.advertiser_id;
            if (!newById[advertiserId]) {
                const advertiserConnectInfo = getAdvertiserConnectInfo(advertiser) || {};
                newById[advertiserId] = {
                    ...advertiser,
                    ...advertiserConnectInfo
                };
                newAllIds.push(advertiserId);
            } else {
                //merge team member advertiser's campaign
                const { campaigns = []} = advertiser;
                const { campaigns: prevCampaigns = [] } = newById[advertiserId];
                const prevCampaignsHashMap = prevCampaigns.reduce((acc, item) => {
                    const { campaign_id } = item;
                    acc[campaign_id] = item;
                    return acc;
                }, {});
                const newCampaignList = [...prevCampaigns];
                campaigns.forEach(item => {
                    const { campaign_id } = item;
                    if (!prevCampaignsHashMap[campaign_id]) {
                        newCampaignList.push(item);
                    }
                })

                const currentCampaignsLength = (advertiser.campaigns || []).length;

                if (prevCampaigns.length < currentCampaignsLength) {
                    const newAdvertiserConnectInfo = getAdvertiserConnectInfo(advertiser) || {};
                    newById[advertiserId] = {
                        ...advertiser,
                        ...newAdvertiserConnectInfo
                    };
                }

                newById[advertiserId].campaigns = newCampaignList;

            }

           //process campaignHashMap
            const { campaigns = [] } = advertiser;
            campaigns.forEach(campaign => {
                const { campaign_id: campaignId } = campaign;
                campaignHashMap[campaignId] = campaign;
                campaignIds.push(campaignId);
            })

            return advertiserId;
        });

        acc.push({
            userId: member.userId,
            advertisers: advertiserIds
        });
        return acc;
    }, []);
    const newAdvertiserData = {
        team: newAdvertiserTeam,
        teamStatus: Status.STATUS_LOADED,
        byId: newById,
        allIds: newAllIds
    }  
    yield (put(setAdvertisers(newAdvertiserData)));
    const campaignLoadStatus = _.get(state, 'campaign.status');
    if (campaignLoadStatus !== campaignStatus.LOADED) {
        const campaignList = Object.values(campaignHashMap);
        campaignIds = _.uniq(campaignIds);
        yield put(setCampaigns(campaignList, campaignIds));
    }
    return Status.STATUS_LOADED
}

function* loadUnassignedAdvertisersSaga(action) {

    const state = yield select();
    const config = yield select(getConfig);

    // fetching
    const res = yield loadAdvertisersApi(config.urlApi, 'unassigned');

    if (!res || res.error) {
        const toast = {
            message: "Error loading unassigned advertisers !",
            action: "Dismiss",
            type: constants.FAILED
        };
        yield put(setLoadAdvertisersStatus(Status.STATUS_ERROR));
        yield put(showToast(toast));
        return Status.STATUS_ERROR
    }

    const { data = [] } = res;
    const newById = {};
    const newAllIds = [];

    const campaignHashMap = {};
    let campaignIds = [];

    // calculate unassignedAdvertisers
    const unassignedUserAdvertisers = data.reduce((acc, userAdvertiser) => {
        const advertisers = _.get(userAdvertiser, 'advertisers', []);
        const advertiserIds = advertisers.map(advertiser => {
            const advertiserId = advertiser.advertiser_id;
            if (!newById[advertiserId]) {
                const advertiserConnectInfo = getAdvertiserConnectInfo(advertiser) || {};
                newById[advertiserId] = {
                    ...advertiser,
                    ...advertiserConnectInfo
                };
                newAllIds.push(advertiserId);
            }

            //process campaignHashMap
            const { campaigns = [] } = advertiser;
            campaigns.forEach(campaign => {
                const { campaign_id: campaignId } = campaign;
                campaignHashMap[campaignId] = campaign;
                campaignIds.push(campaignId);
            })

            return advertiserId;
        });

        acc.push({
            userId: userAdvertiser.userId,
            advertisers: advertiserIds
        });
        return acc;
    }, []);
    
    const newAdvertiserData = {
        unassignedAdvertisers: unassignedUserAdvertisers,
        unassignedStatus: Status.STATUS_LOADED,
        byId: newById,
        allIds: newAllIds
    }

    yield (put(setAdvertisers(newAdvertiserData)));
    const campaignLoadStatus = _.get(state, 'campaign.status');
    if (campaignLoadStatus !== campaignStatus.LOADED) {
        const campaignList = Object.values(campaignHashMap);
        campaignIds = _.uniq(campaignIds);
        yield put(setCampaigns(campaignList, campaignIds));
    }
    return Status.STATUS_LOADED
}

function* loadAdvertisersSaga(action) {
    const state = yield select();

    const advertiserStatus = _.get(state, 'advertiser.status', '');
    if (advertiserStatus === Status.STATUS_LOADING) {
        return;
    }
    yield put(setLoadAdvertisersStatus(Status.STATUS_LOADING));
    // run sagas in parallel
    const res = yield all([
        loadAdvertiserOfCurrentUsersSaga(action),
        loadAdvertiserOfTeamMembersSaga(action),
        loadUnassignedAdvertisersSaga(action)
    ]);
    const [
        selfStatus,
        teamStatus,
        unassignedStatus
    ] = res;

    if (
        selfStatus === Status.STATUS_LOADED &&
        teamStatus === Status.STATUS_LOADED &&
        unassignedStatus === Status.STATUS_LOADED
    ) {
        yield put(setLoadAdvertisersStatus(Status.STATUS_LOADED));
    } else {
        yield put(setLoadAdvertisersStatus(Status.STATUS_ERROR));
    }
}

function* updateAdvertiserPermissionsSaga(action) {
    const { advertiserId, selectedUsers: users } = action.payload;
    const config = yield select(getConfig);
    const state = yield select();
    yield put(loadAdvertiser(advertiserId, {
        loading: true,
        loaded: false
    }));

    const res = yield updateAdvertiserPermissionsApi(config.urlApi, advertiserId, users);
    const selectedUsers = _.get(res, 'users', []);
    const {
        selectedUsersHashMap,
        newOwner,
        newEditors,
        newViewers
    } = selectedUsers.reduce((acc, user) => {
        const { id } = user;
        if (id) {
            acc.selectedUsersHashMap[id] = user;
            if (user.role === OWNER) {
                acc.newOwner = id;
            } else if (user.role === EDITOR && acc.newEditors.indexOf(id) === -1) {
                acc.newEditors.push(id);
            } else if (user.role === VIEWER && acc.newViewers.indexOf(id) === -1) {
                acc.newViewers.push(id);
            }
        }
        return acc;
        }, {
        newOwner: '',
        newEditors: [],
        newViewers: [],
        selectedUsersHashMap: {}
    });

    if (!res || res.error || !newOwner) {
        const toast = {
            message: "Fail sharing advertiser",
            action: "Dismiss",
            type: constants.FAILED
        };
        yield put(loadAdvertiser(advertiserId, {
            loading: false,
            loaded: false
        }));
        return yield put(showToast(toast));
    }

    const unassignedAdvertisers = _.get(state, [advertiserNamespace, 'unassignedAdvertisers'],[]);
    let newUnassignedAdvertisers = [...unassignedAdvertisers];

    //process user info
    const getAdvertiserById = yield select(getAdvertiser);
    const advertiser = getAdvertiserById(advertiserId);
    const { owner: prevOwner, campaigns = []} = advertiser;
    if (prevOwner != newOwner) {
        const numCampaign = campaigns.length;
        const state = yield select(state => state[userManagementNamespace]);
        const users = [..._.get(state, 'users.data', [])];

        const newOwnerIndex = _.findIndex(users, { id: newOwner});
        const newOwnerData = _.cloneDeep(users[newOwnerIndex]);
        if (newOwnerData) {
            const ownerNumCampaigns = newOwnerData.numCampaigns || 0;
            const ownerNumAdvertisers = newOwnerData.numAdvertisers || 0;
            newOwnerData.numCampaigns = ownerNumCampaigns + numCampaign;
            newOwnerData.numAdvertisers = ownerNumAdvertisers + 1;
            users[newOwnerIndex] = newOwnerData;
        }

        const prevOwnerIndex = _.findIndex(users, { id: prevOwner});
        const prevOwnerData = _.cloneDeep(users[prevOwnerIndex]);
        if (prevOwnerData) {
            const ownerNumCampaigns = prevOwnerData.numCampaigns || 0;
            const ownerNumAdvertisers = prevOwnerData.numAdvertisers || 0;
            prevOwnerData.numCampaigns = ownerNumCampaigns > numCampaign ? ( ownerNumCampaigns - numCampaign ) : 0;
            prevOwnerData.numAdvertisers = ownerNumAdvertisers > 0 ? ( ownerNumAdvertisers - 1 ) : 0;
            users[prevOwnerIndex] = prevOwnerData;
        }
        
        yield put(setOrgUser(users));

        //process unassignedAdvertisers
        newUnassignedAdvertisers = unassignedAdvertisers.reduce((acc, user) => {
            const { userId, advertisers } = user;
            if (userId === prevOwner) {
                const newAdvertisers = advertisers.filter(item => item !== advertiserId);
                if (newAdvertisers.length > 0 ) {
                    acc.push({
                        ...user,
                        advertisers: newAdvertisers
                    })
                }
            } else {
                acc.push(user);
            }
            return acc;
        }, []);
    }

    //process advertiser info
    const currentUser = yield select(selectUser);
    const { userId: myId } = currentUser;
    const teamsInfo =  _.get(state, [userManagementNamespace, 'teams', 'data']);
    const { myMemberIds, userManagerHashMap } = teamsInfo && teamsInfo.reduce((acc, team) => {
        const { memberIds, managerIds } = team;
        memberIds.forEach(memberId => {
            let managerList = acc.userManagerHashMap[memberId] || [];
            managerList = [...managerList, ...managerIds];
            acc.userManagerHashMap[memberId] = managerList;
        })
        managerIds.forEach(memberId => {
            let managerList = acc.userManagerHashMap[memberId] || [];
            managerList = [...managerList, ...managerIds];
            acc.userManagerHashMap[memberId] = managerList;
        })

        if (team.managerIds.indexOf(myId) !== -1) {
            memberIds.forEach(memberId => {
                acc.myMemberIds.indexOf(memberId) === -1 &&
                memberId !== myId &&
                acc.myMemberIds.push(memberId);
            })
        }
        return acc;
    }, {
        myMemberIds: [],
        userManagerHashMap: {}
    })
    
    
    let isAccessAdvertiser;//check if I have access to the advertiser
    let isMemberHasAccessToAdvertiser;//check if my members (if I'm manager) have access to advertiser 

    //process self
    const self = _.get(state, [advertiserNamespace, 'self']);
    const newAdvertiserSelf = [...self];
    const selfIndex = newAdvertiserSelf.indexOf(advertiserId);
    if (selectedUsersHashMap[myId]) {
        selfIndex === -1 && newAdvertiserSelf.push(advertiserId);
        isAccessAdvertiser = true;
    } else {
        selfIndex !== -1 && newAdvertiserSelf.splice(selfIndex, 1);
    }
    //process team
    const team =  _.get(state, [advertiserNamespace, 'team']);
    const teamHashMap = team && team.reduce((acc, user) => {
        if (user.userId) {
          acc[user.userId] = user.advertisers;
        }
        return acc;
      }, {});
    const newAdvertiserTeam = myMemberIds && myMemberIds.reduce((acc, id) => {
        let advertisers = teamHashMap[id];
        if (!advertisers) {
            if (selectedUsersHashMap[id]) {
                advertisers = [advertiserId]
                isMemberHasAccessToAdvertiser = true;
            }
        } else {
            const index = advertisers.indexOf(advertiserId);
            if (selectedUsersHashMap[id]) {
                index === -1 && advertisers.push(advertiserId)
                isMemberHasAccessToAdvertiser = true;
            } else {
                index !== -1 && advertisers.splice(index, 1);
            }
        }
        advertisers && acc.push({
            userId: id,
            advertisers
        })
        return acc;
    }, []);

    //process byId and allId
    if (!isAccessAdvertiser && !isMemberHasAccessToAdvertiser) {
    //If I and my member doesn't have access to advertiser anymore
        //Process campaign
        /*
            The case is: I and my member (if have) don't have any access to the advertiser
            but some of us have access to one of its campaign:
                + is in editors
                + is in viewers
                + manager of some editors
                + manager of some viewers
            If it true, keep the advertiser in redux
            If not, remove advertiser
        */
        const advertiser = _.get(state, [advertiserNamespace, 'byId', advertiserId]);
        const campaigns = advertiser && advertiser.campaigns || [];
        const myUserListIds = myMemberIds ? [...myMemberIds, myId] : [myId];
        let isMyUserAccessCampaigns;
        for (let i = 0; i < myUserListIds; i++) {
            const id = myUserListIds[i];
            for (let j = 0; i < campaigns.length; j++) {
                const campaignId = campaigns[j] && campaigns[j].campaign_id;
                const campaign = _.get(state, [campaignNamespace, 'byId', campaignId]);
                if (!campaign) { continue; }
                const { editors, viewers } = campaign;
                editors && editors.forEach(editorId => {
                    if (editorId === id || userManagerHashMap[editorId].indexOf(id) !== -1) {
                        isMyUserAccessCampaigns = true;  
                    }
                })
                viewers && viewers.forEach(viewerId => {
                    if (viewerId === id || userManagerHashMap[viewerId].indexOf(id) !== -1) {
                        isMyUserAccessCampaigns = true;  
                    }
                })

            }
        }
        /*I and my member (if have) don't have any access to the advertiser and even advertiser's campaign */
        if (!isMyUserAccessCampaigns) {
            yield (put(removeAdvertiser({ advertiser_id: advertiserId })));
        } 
    } else {
        yield (put(setAdvertiserPermissions({
            advertiserId,
            owner: newOwner,
            editors: newEditors,
            viewers: newViewers
        })));
    }

    //process advertiser permissions
    yield (put(setAdvertisers({
        self: newAdvertiserSelf,
        team: newAdvertiserTeam,
        unassignedAdvertisers: newUnassignedAdvertisers
    })));
    yield put(loadAdvertiser(advertiserId, {
        loading: false,
        loaded: true
    }));
}

function* loadAdvertiserLogoSaga(action) {
    const { advertiserId } = action.payload;
    const config = yield select(getConfig);
    const getAdvertiserById = yield select(getAdvertiser);
    const advertiser = getAdvertiserById(advertiserId);
    const advertiserLogo = advertiser.logo || {}; //content return logo as null, TODO: using lodash get when content API is removed
    const { logoTDOid, loadedTimeTracking, TDOId, url } = advertiserLogo;
    const id = logoTDOid || TDOId; //TODO: remove TDOId when content API is removed

    const newTimeTracking = (new Date()).getTime();
    let isExpired = true;
    if (loadedTimeTracking) {
        const loadedTimeRange = (newTimeTracking - loadedTimeTracking)/1000;
        //TODO: get logoExpiredTimeRange (that client send when upload logo) from graphql/API 
        const logoExpiredTimeRange = DEFAULT_ADVERTISER_LOGO_EXPIRE_TIME;
        isExpired = url && (loadedTimeRange > logoExpiredTimeRange);
    }
    if (!id || !isExpired ) {
        return;
    }

    yield put(loadAdvertiser(advertiserId, {
        loading: true,
        loaded: false
    }));
    const res = yield loadMediaContentApi(config.urlApi, id);
    if (res && res.error) {
        const toast = {
            message: 'Error loading advertiser logo!',
            action: "Dismiss",
            type: constants.FAILED
        };
        yield put(showToast(toast));
    } else {
        const logo = {
            ...advertiserLogo,
            url: res,
            loadedTimeTracking: newTimeTracking
        }
        yield put(updateAdvertiser({ advertiser_id: advertiserId, logo }));
    }
    yield put(loadAdvertiser(advertiserId, {
        loading: false,
        loaded: true
    }));
}

function* ga4InviteToConnectSaga(action) {
    const { advertiserId, inviteRecipientEmails, inviteMessage } = action.payload;
    const config = yield select(getConfig);
    yield put(loadAdvertiser(advertiserId, {
        loading: true,
        loaded: false
    }));
    const res = yield ga4InviteToConnectApi(
        config.urlApi,
        {
            advertiserId,
            inviteMessage: inviteMessage || DEFAULT_MESSAGE,
            inviteRecipientEmails
        }
        );

    // handle showing toast
    let toast;
    if (res && res.code === 'SUCCESS') {
        toast = {
            message: "Invitation sent!",
            action: "Dismiss",
            type: constants.SUCCESS
        };
    } else {
        toast = {
            message: "Fail sending invitation.",
            action: "Dismiss",
            type: constants.FAILED
        };
    }
    yield put(showToast(toast));

    yield put(loadAdvertiser(advertiserId, {
        loading: false,
        loaded: true
    }));
}

function* sendAlertForAdvertiserConnectionSaga(action) {
  const { advertiserId, recipientEmails, message } = action.payload;
  const config = yield select(getConfig);
  yield put(
    loadAdvertiser(advertiserId, {
      loading: true,
      loaded: false
    })
  );
  const res = yield sendAlertForAdvertiserConnection(
    config.urlApi,
    advertiserId,
    recipientEmails,
    message
  );

  // handle showing toast
  let toast;
  if (res && res.code === 'SUCCESS') {
    toast = {
      message: 'Alert sent!',
      action: 'Dismiss',
      type: constants.SUCCESS
    };
  } else {
    toast = {
      message: 'Fail sending alert.',
      action: 'Dismiss',
      type: constants.FAILED
    };
  }
  yield put(showToast(toast));

  yield put(
    loadAdvertiser(advertiserId, {
      loading: false,
      loaded: true
    })
  );
}

function* getWeblogFilesSaga(action) {
    const { advertiserId } = action.payload;
    const config = yield select(getConfig);
    
    yield put(loadAdvertiser(advertiserId, {
        loading: true,
        loaded: false
    }));

    // call api
    const res = yield getWeblogFilesByAdvertiserApi(config.urlApi, [advertiserId]);

    // handle data
    if (res && res.error) {
        const toast = {
            message: 'Error loading weblog files for the advertiser!',
            action: "Dismiss",
            type: constants.FAILED
        };
        yield put(showToast(toast));
    } else {
        yield put(updateAdvertiser({ advertiser_id: advertiserId, web_log_files: _.get(res, '[0].uploadedFiles', []) }));
    }
    yield put(loadAdvertiser(advertiserId, {
        loading: false,
        loaded: true
    }));
}

function* updateCutoverDateSaga(action) {
    const { advertiserId, newDate } = action.payload;
    const config = yield select(getConfig);

    yield put(loadAdvertiser(advertiserId, {
        loading: true,
        loaded: false
    }));
    
    // call api
    const res = yield updateCutoverDateApi(config.urlApi, advertiserId, newDate);

    // handle data
    if (res && res.error) {
        const toast = {
            message: 'Error update cutover date for the advertiser!',
            action: "Dismiss",
            type: constants.FAILED
        };
        yield put(showToast(toast));
    } else {
        yield put(updateAdvertiser({ advertiser_id: advertiserId, google_analytics_cutover_date: newDate }));
    }
    yield put(loadAdvertiser(advertiserId, {
        loading: false,
        loaded: true
    }));

}

export function* deleteGA4ConnectionSaga(action) {
    const { advertiserId } = action.payload;
    const config = yield select(getConfig);
    const getAdvertiserById = yield select(getAdvertiser);
    
    yield put(loadAdvertiser(advertiserId, {
        loading: true,
        loaded: false,
    }));
    
    const response = yield deleteGA4ConnectionApi(config.urlApi, advertiserId);
    
    if (!response || response.error || response.code === 'FAILED') {
        const statusCode = _.get(response, 'response.status', null);
        const advertiser = getAdvertiserById(advertiserId);
        yield put(updateAdvertiser({ ...advertiser, ga4ConnectionRemovalStatus: DeleteConnectionStatus.FAILED }));
        const message = `Delete GA4 connection failure for advertiser: ${advertiser.advertiser_name}`;
        const toast = {
            message,
            action: 'Dismiss',
            type: constants.FAILED,
        };
        if (statusCode === 405) {
            toast.message = _.get(response, 'response.data.message', message);
        }
        yield put(showToast(toast));
    } else {
        const { data: advertiser } = response;
        yield put(updateAdvertiser({ ...advertiser, ga4ConnectionRemovalStatus: DeleteConnectionStatus.SUCCESS }));
        
        const getCampaigns = yield select(getCampaignByAdvertiserId);
        const campaigns = getCampaigns(advertiserId) || [];
        yield all(campaigns.map(campaign => {
            return put(removeCampaignData(campaign.campaign_id))
        }))
    }
    yield put(loadAdvertiser(advertiserId, {
        loading: false,
        loaded: true,
    }));
}

export function* getListPixelSaga(action) {
    const { advertiserId, pixelIds  } = action.payload;

    const config = yield select(getConfig);
    yield put(updateAdvertiser({ advertiser_id: advertiserId, advertiserPixelDetailStatus: 'loading' }));

    // call api
    const res = yield getListPixelApi(config.urlApi, pixelIds);

    // handle data
    if (res && res.error) {
        const toast = {
            message: 'Error loading pixel list for the advertiser!',
            action: "Dismiss",
            type: constants.FAILED
        };
        yield put(showToast(toast));
    } else {
        yield put(updateAdvertiser({ advertiser_id: advertiserId, advertiserPixelDetail: _.get(res, 'data', []) }));
    }
    yield put(updateAdvertiser({ advertiser_id: advertiserId, advertiserPixelDetailStatus: 'loaded' }));

}

export function* createAdvertiserPixelSaga(action) {
    const { advertiserId, data } = action.payload;
    const {
        pixelName,
        pixelDescription,
        emailInfo
    } = data;
    const requestPayload = {
        advertiserId,
        pixelName,
        pixelDescription,
        inviteRecipientEmails: _.get(emailInfo, 'emails', []),
        inviteMessage: _.get(emailInfo, 'message', '')
    }
    const config = yield select(getConfig);
    const getAdvertiserById = yield select(getAdvertiser);
    const advertiser = getAdvertiserById(advertiserId);
    const advertiserPixelIDs = _.get(advertiser, 'advertiserPixelIDs', []);
    
    yield put(updateAdvertiser({ advertiser_id: advertiserId, pixelListUpdateStatus: Status.STATUS_LOADING }));
    const res = yield createNewPixelApi(config.urlApi, requestPayload);
    const advertiserPixels = _.get(advertiser, 'advertiserPixelDetail', []);
    let newAdvertiserPixels = advertiserPixels;

    if (res && res.error) {
        const toast = {
            message: 'Error creating pixel for the advertiser!',
            action: "Dismiss",
            type: constants.FAILED
        };
        yield put(showToast(toast));
        yield put(updateAdvertiser({ advertiser_id: advertiserId, pixelListUpdateStatus: Status.STATUS_ERROR }));
    } else {
        const newPixel = _.pick(res.pixel || {}, [
          'pixelCreatedAt',
          'pixelDescription',
          'pixelId',
          'pixelName',
          'isNewlyCreated',
          'pixelUUID'
        ]);
        const newPixelId = _.get(newPixel, 'pixelId', '')
        const newAdvertiserPixelsWithNewLabel = [
            {
                ...newPixel,
                isNewlyCreated: true
            },
            ...advertiserPixels,
        ]
        newAdvertiserPixels = [
            newPixel,
            ...advertiserPixels,
        ]
        yield put(updateAdvertiser({
            advertiser_id: advertiserId,
            advertiserPixelDetail: newAdvertiserPixelsWithNewLabel,
            pixelListUpdateStatus: Status.STATUS_LOADED,
            advertiserPixelIDs: newPixelId ? _.uniq([...advertiserPixelIDs, String(newPixelId)]) : advertiserPixelIDs
        }));
        yield delay(5000)
        yield put(updateAdvertiser({ advertiser_id: advertiserId, advertiserPixelDetail: newAdvertiserPixels }));
    }
}

export function* updatePixelSaga(action) {
  const { advertiserId, pixel } = action.payload;
  const pixelId = _.get(pixel, 'pixelId');
  const config = yield select(getConfig);

  if (pixelId) {
    yield put(
      updatePixelStatusById(advertiserId, pixelId, Status.STATUS_LOADING)
    );
    const res = yield updatePixelAdvertiserApi(config.urlApi, pixel);

    if (res && res.error) {
      const toast = {
        message: 'Error updating pixel info!',
        action: 'Dismiss',
        type: constants.FAILED,
      };
      yield put(showToast(toast));
      yield put(
        updatePixelStatusById(advertiserId, pixelId, Status.STATUS_ERROR)
      );
    } else {
      const getAdvertiserById = yield select(getAdvertiser);
      const advertiser = getAdvertiserById(advertiserId);
      const advertiserPixelDetail = _.get(
        advertiser,
        'advertiserPixelDetail',
        []
      );
      const newPixelDetail = advertiserPixelDetail.map((pixelDetail) => {
        if (pixelDetail.pixelId === pixelId) {
          return {
            ...pixelDetail,
            ...(_.omit(res, 'advertiserId')),
          };
        }
        return pixelDetail;
      });
      yield put(
        updateAdvertiser({
          advertiser_id: advertiserId,
          advertiserPixelDetail: newPixelDetail,
        })
      );
      yield put(
        updatePixelStatusById(advertiserId, pixelId, Status.STATUS_LOADED)
      );
    }
  }
}

export function* updateStatusAdvertiser(action) {
  const { advertiser } = action.payload;
  if(advertiser && Object.keys(advertiser).length !== 0){
  const advertiserConnectInfo =
    { ...advertiser, ...getAdvertiserConnectInfo(advertiser) } || {};
  yield put(updateAdvertiser(advertiserConnectInfo, null));
  }
}

export default function* auth() {
  yield all([
    takeEvery(REMOVE_ADVERTISER_SAGA, removeAdvertiserSaga),
    takeEvery(ADD_ADVERTISER_SAGA, addAdvertiserSaga),
    takeEvery(
      ADD_ADVERTISER_WITHOUT_GA_INVITE_SAGA,
      addAdvertiserWithoutGAInviteSaga
    ),
    takeEvery(CHECK_GA_CONNECTION_SAGA, checkGaConnectionSaga),
    takeEvery(UPDATE_ADVERTISER_SAGA, updateAdvertiserSaga),
    takeEvery(GET_ADVERTISER_SAGA, getAdvertiserSaga),
    // takeEvery(UPDATE_CHART_DATA_ADVERTISER_SAGA, updateAdvertiserChartData),
    takeEvery(UPDATE_ADVERTISER_DETAIL_SAGA, updateAdvertiserDetail),
    takeEvery(GET_STATION_SAGA, getStationSaga),
    takeEvery(NEXT_STEP_SAGA, nextStepSaga),
    takeEvery(UPDATE_ADVERTISER_PERMISSIONS, updateAdvertiserPermissionsSaga),
    takeEvery(LOAD_ADVERTISERS, loadAdvertisersSaga),
    takeEvery(LOAD_ADVERTISER_LOGO, loadAdvertiserLogoSaga),
    takeEvery(SEND_INVITE, sendInviteSaga),
    takeEvery(DISMISS_INVITE, dismissInviteSaga),
    takeEvery(GET_WEBLOG_FILES, getWeblogFilesSaga),
    takeEvery(GA4_INVITE_TO_CONNECT, ga4InviteToConnectSaga),
    takeEvery(SEND_ALERT_ADVERTISER_CONNECTION, sendAlertForAdvertiserConnectionSaga),
    takeEvery(UPDATE_CUTOVER_DATE, updateCutoverDateSaga),
    takeEvery(DELETE_GA4_CONNECTION, deleteGA4ConnectionSaga),
    takeEvery(GET_LIST_PIXEL, getListPixelSaga),
    takeEvery(CREATE_ADVERTISER_PIXEL, createAdvertiserPixelSaga),
    takeEvery(UPDATE_PIXEL, updatePixelSaga),
    takeEvery(UPDATE_STATUS, updateStatusAdvertiser)
  ]);
}